import { render, staticRenderFns } from "./IrMsbc.vue?vue&type=template&id=b10a6a06&"
import script from "./IrMsbc.js?vue&type=script&lang=js&"
export * from "./IrMsbc.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports